import _Credits from './credits';
export { _Credits as Credits };


// WEBPACK FOOTER //
// ./src/modules/subscription/index.js